import { JobEnsureResponseSchema, JobStatusResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type JobStatusResponseInput = z.input<typeof JobStatusResponseSchema>;
export type JobStatusResponseOutput = z.output<typeof JobStatusResponseSchema>;

export function serializeJobStatusResponse(payload: JobStatusResponseInput): JobStatusResponseOutput {
  return JobStatusResponseSchema.parse(payload);
}

export type JobEnsureResponseInput = z.input<typeof JobEnsureResponseSchema>;
export type JobEnsureResponseOutput = z.output<typeof JobEnsureResponseSchema>;

export function serializeJobEnsureResponse(payload: JobEnsureResponseInput): JobEnsureResponseOutput {
  return JobEnsureResponseSchema.parse(payload);
}
